import { startOfDay } from 'date-fns';
import { useQueryParams } from 'hooks/useQueryParams';
import { useMemo } from 'react';
import { closestTwiceMonthlyDate } from 'utils/helpers';
import { replaceUrl } from 'utils/helpers/replaceUrl';
import { DEFAULT_FREQUENCY_ID, getSelectedFrequencyId } from 'utils/store/frequency';

export function usePaymentDate() {
  const { payment_date: paymentDate } = useQueryParams();
  /**
   * Which date can be selected, and/or sometimes automatically shifted to, is
   * dependent on the currently selected Frequency value (for recurring payments).
   */
  const selectedFrequencyId = getSelectedFrequencyId();

  return {
    selectedPaymentDate: useMemo(
      () => getPaymentDate(paymentDate, selectedFrequencyId),
      [paymentDate, selectedFrequencyId]
    ),
    setPaymentDate,
  };
}

function getPaymentDate(dateString: string | null = null, frequencyId: string) {
  const parsedDate = new Date(parseInt(dateString ?? ''));
  return validateDate(isNaN(parsedDate.getTime()) ? new Date() : parsedDate, frequencyId);
}

async function setPaymentDate(date?: Date | string | number, frequencyId?: string) {
  const validatedDate = validateDate(
    date && date instanceof Date ? date : new Date(date ?? new Date()),
    frequencyId ?? DEFAULT_FREQUENCY_ID
  );
  await replaceUrl({
    payment_date: validatedDate.getTime(),
  });
}

function validateDate(date: Date, frequencyId: string) {
  return date < startOfDay(new Date()) ? new Date() : validateDateWithFrequency(date, frequencyId);
}

function validateDateWithFrequency(date: Date, frequencyId: string) {
  return frequencyId === 'TWICE_MONTHLY' ? closestTwiceMonthlyDate(date) : date;
}
